import React, { useEffect, useMemo, useRef, useState } from "react";
import { Textarea } from "@aqar-app/react-ui";
import {
  getDynamicLabel,
  useRevalidateAndCalculations,
  validate,
} from "@/components/add-v2/validate";
import { dispatchCtxChange } from "@/components/add-v2/ui";
import css from "./.module.scss";

export function TextAreaComponent({
  rules,
  label,
  dependencies,
  name,
  ctxRef,
  value: initialValue,
  defaultValue,
  nested,
  onChange,
  calculations,
  visibilityRules,
  ...props
} = {}) {
  const [value, setValue] = useState(initialValue || defaultValue);
  const [error, setError] = useState(null);
  const rootRef = useRef(null);

  const labelObject = useMemo(
    () => (label?.dynamic ? getDynamicLabel({ label, ctx }) : label),
    [label],
  );
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    root.addEventListener("validate", (e) => {
      setError(e?.detail?.error);
    });
  }, []);
  return (
    <div ref={rootRef}>
      <p>{labelObject?.ar || name}</p>
      <div className={css.textAreaWrapper}>
        <Textarea
          {...props}
          className={css.textArea + (error ? " " + css.hasError : "")}
          name={name}
          value={value}
          onChange={(e) => {
            const currentValue = e.target.value;

            setValue(currentValue);

            dispatchCtxChange(e.target, {
              value: currentValue?.trim(),
              name,
              nested,
            });
          }}
        />
        <small>
          {value?.length || 0}/{props.maxLength}
        </small>
      </div>
      <p className={css.error}>{error}</p>
    </div>
  );
}
